import { Plus } from 'lucide-react';
import React, { useState } from 'react';
import { Button } from '../../../components/ui/button';
import { CreateSegmentDialog } from './create-segment-dialog';

export const CreateSegmentButton: React.FC = () => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Button onClick={() => setDialogOpen(true)}>
        <Plus />
        New Segment
      </Button>
      {dialogOpen && (
        <CreateSegmentDialog onClose={() => setDialogOpen(false)} />
      )}
    </>
  );
};
